import { Edit, ShowButton, TopToolbar } from 'react-admin';

import TabbedCreateEditForm from './TabbedCreateEditForm';

const Actions = () => {
  return (
    <TopToolbar>
      <ShowButton />
    </TopToolbar>
  );
};

export const OfferEdit = () => (
  <Edit redirect='list' actions={<Actions />}>
    <TabbedCreateEditForm isEditMode />
  </Edit>
);

export default OfferEdit;
